import { render, staticRenderFns } from "./VizrtKundenumsaetzeTabelle.vue?vue&type=template&id=712f2de9&scoped=true&"
import script from "./VizrtKundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
export * from "./VizrtKundenumsaetzeTabelle.vue?vue&type=script&lang=js&"
import style0 from "./VizrtKundenumsaetzeTabelle.vue?vue&type=style&index=0&id=712f2de9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712f2de9",
  null
  
)

export default component.exports